import { render, staticRenderFns } from "./ListCategoryNew.vue?vue&type=template&id=d8481bfa"
import script from "./ListCategoryNew.vue?vue&type=script&lang=js"
export * from "./ListCategoryNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports